import { render } from "./IndicatorPoint.vue?vue&type=template&id=283310d2&scoped=true"
const script = {}

import "./IndicatorPoint.vue?vue&type=style&index=0&id=283310d2&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-283310d2"]])

export default __exports__